import {
  PathsV1VehicleValuationSearchPostParametersQueryExtend,
  PathsV1VehicleValuationSearchPostParametersQueryOrderByDirection,
  PathsV1VehicleValuationSearchPostParametersQueryOrderByField,
  VehicleValuationStatus,
} from "@/api-schema-enums";
import { UNLIMITED_PAGE_SIZE } from "@/common/api/_defaults";
import { useVehicleValuationSearchQuery } from "@/common/api/vehicle-valuation/use-vehicle-valuation-search.query";
import { useCallback, useState } from "react";

const PAGE_SIZE = 3;
const EXTEND = [PathsV1VehicleValuationSearchPostParametersQueryExtend.Vehicle] as const;
const ORDER_BY = [
  {
    direction: PathsV1VehicleValuationSearchPostParametersQueryOrderByDirection.Desc,
    field: PathsV1VehicleValuationSearchPostParametersQueryOrderByField.CreatedAt,
  },
] as const;

export function useVehicleValuationHistory(vehicleUuid: string) {
  const [showAll, setShowAll] = useState(false);
  const keepPreviousData = useCallback(<T>(prev: T | undefined) => prev, []);

  const query = useVehicleValuationSearchQuery({
    enabled: !!vehicleUuid,
    options: {
      parameters: {
        page: 1,
        pageSize: showAll ? UNLIMITED_PAGE_SIZE : PAGE_SIZE,
        extend: [...EXTEND],
        orderBy: [...ORDER_BY],
      },
      body: {
        vehicle: [vehicleUuid],
        status: [VehicleValuationStatus.Confirmed],
      },
    },
    queryOptions: {
      placeholderData: keepPreviousData,
    },
  });

  const entries = query.data?.data ?? [];
  const total = query.data?.meta.total ?? 0;
  const hasMore = !showAll && total > PAGE_SIZE;
  const isExpanding = showAll && query.isPlaceholderData;
  const displayEntries = showAll ? entries : entries.slice(0, PAGE_SIZE);

  const toggleShowAll = () => setShowAll((prev) => !prev);

  return {
    isPending: query.isPending,
    isError: query.isError,
    isEmpty: !query.isPending && entries.length === 0,
    displayEntries,
    hasMore,
    isExpanding,
    showAll,
    toggleShowAll,
    skeletonRowCount: PAGE_SIZE,
  };
}
